var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('div',{staticClass:"mian"},[_c('div',{attrs:{"id":"AIInterlocutor"}},[_c('left'),_c('right')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }